import {
  Stack,
  Button,
  Text,
  VStack,
  Icon,
  useBreakpointValue
} from "@chakra-ui/react"
import { FaHeart } from 'react-icons/fa'
import SimpleThreeColumns from './ThreeColGrid'

export default function WithBackgroundImage() {
  return (
    <VStack
      w={"full"}
      minH={{ base: 'auto', md: '87vh'}}
      pb={{ base: 6, md: 10 }}
      pt={{ base: 4, md: 0 }}
      bgImage="url('/images/4BearsBridge.jpg')"
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
      justify={"center"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        h={{ base: 'auto', md: '100%' }}
        px={useBreakpointValue({ base: 4, md: 8 })}
        py={{ base: 8, md: 0 }}
        bgGradient={"linear(to-r, blackAlpha.500, transparent)"}
        spacing={{ base: 8, md: 150 }}
      >
        <Stack
          maxW={"2xl"}
          spacing={{ base: 4, md: 6 }}
          mb={{ base: 4, md: 10 }}
          align={{ base: 'center', md: 'flex-start' }}
          textAlign={{ base: 'center', md: 'left' }}
        >
          <Text as='u'
            color={"gray.100"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: "4xl", md: "5xl" })}
          >
            Hidatsa Áabaci
          </Text>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: "3xl", md: "4xl" })}
            // bg={'rgba(50,50,50,0.3)'}
            rounded={'sm'}
          >
            A place for our children and community
          </Text>
          <Stack direction={{ base: "column", sm: "row" }} spacing={3} flexWrap="wrap">
              <Button
                as="a"
                href="/curriculum#lessons"
                bg={"red.400"}
                rounded={"full"}
                color={"white"}
                _hover={{ bg: "red.500" }}
                size="lg"
              >
                Curriculum Work
              </Button>
              <Button
                as="a"
                href="/dictionary"
                bg={"teal.500"}
                rounded={"full"}
                color={"white"}
                _hover={{ bg: "teal.600" }}
                size="lg"
              >
                Explore Dictionary
              </Button>
              <Button
                as="a"
                href="/contact#donate"
                bg={"pink.500"}
                rounded={"full"}
                color={"white"}
                _hover={{ bg: "pink.600" }}
                size="lg"
                leftIcon={<Icon as={FaHeart} />}
              >
                Donate
              </Button>
            </Stack>
        </Stack>
        <Stack 
          bg={'rgba(50,50,50,0.4)'}
          rounded={'md'}
          >
          <SimpleThreeColumns />
        </Stack>
      </VStack>
    </VStack>
  )
}
